import React, { useMemo } from 'react';
import { Space } from 'antd';
import StandardTable from '../../StandardTable/StandardTable';
import { fetchSearchRes } from '../../../api/services';
import styles from './index.module.less';

const SearchResult = ({ type, value }) => {
  const columns = [
    {
      title: 'NAME',
      dataIndex: 'name',
      width: '25%',
      onCell: () => ({
        colSpan: 4,
      }),
    },
    {
      title: 'TYPE',
      width: '25%',
    },
    {
      title: 'DATE',
      width: '25%',
    },
    {
      title: 'FILE',
      width: '25%',
    },
  ];
  const category = useMemo(() => {
    switch (type) {
      case 'firmware':
        return 'firmware';
      case 'documents':
        return 'Specifications,Manuals,DeveloperDocumentation,StructuralDrawings,Flyers';
      case 'DeveloperTools':
        return 'DeveloperTools,apps,dockers';
      default:
        return undefined;
    }
  }, [type]);
  const tableProps = useMemo(() => {
    const commonParams = {
      name: value,
      category,
    };
    return {
      key: `table-${type}`,
      request: fetchSearchRes,
      params: commonParams,
      expandable: type,
    };
  }, [value, type, columns]);
  return (
    <div className={styles.container}>
      <Space className={styles.customTableHeader}>
        {columns.map((v, index) => (
          <div
            key={`header-row-${index}`}
            className={styles.headerItem}
          >
            {v.title}
          </div>
        ))}
      </Space>
      <div className={styles.tableContainer}>
        <StandardTable {...tableProps} />
      </div>
    </div>
  );
};
export default SearchResult;
